import { Button, Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import iconSvg from "../../../../assets/images/icon/check.svg";
import iconNext from "../../../../assets/images/icon/next-arrow.svg";
import alert from "../../../../assets/images/ndid/alert.png";
import "../../../../i18n/i18n";
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../i18n/i18n.constants";
import { i18n } from '../../../../i18n/i18n';
// import logoNdid from "../../../../assets/images/ndid/logo_ndid.jpg";

const DaolSecNdidPage: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation(namespaces.pages.daolsecNdid);
  const param_token = localStorage.getItem("param_token");
  const param_identifier = localStorage.getItem("param_identifier");
  const param_ndid_phase = localStorage.getItem("param_ndid_phase");

  return (
    <>
    {/* {console.log('useTranslation(namespaces.pages.daolInvNdidPage)', i18n.language)}  */}
    <div className="home-page mainndid-page">
      <Row className="container-main daol-ndid">
        <div className="content-right col-sm-8 text-center">
          {(param_token === "undefined" || param_token === "") ? ( // None token
            <>
            <img src={alert} className="img-popup" alt="alert" />
            <p className="text-header"><b>{t("title")}</b></p>
            <p>{t("text_descrip")}</p><br></br>
            <span>{t("token_undefine_title")}</span>
            <p>{t("token_undefine")}</p>
            </>
          ) : (
            <>
            <p className="text-header"><b>{t("title")}</b></p>
            <p>{t("text_descrip")}</p>
            {/* <p><img src={logoNdid} alt="Logo-Ndid" width="45%"/></p> */}
            <p className="sub-text-header">{t("descrip_p1")}</p>
            <div className="text-left descrip-content">
              <p><img src={iconSvg} alt="icon" />{t("descrip_p2")}</p>
              <p><img src={iconSvg} alt="icon" />{t("descrip_p3")}</p>
              <p><img src={iconSvg} alt="icon" />{t("descrip_p4")}</p>
              <p><img src={iconSvg} alt="icon" />{t("descrip_p5")}</p>
              <p><img src={iconSvg} alt="icon" />{t("descrip_p6")}</p>
              <p><img src={iconSvg} alt="icon" />{t("descrip_p7")}</p>
            </div>
            <div className="container-button btn-ndid">
              <span className="remark">{t("descrip_remark")}</span>
              <Button
                type="primary"
                className="btn-next"
                onClick={() => 
                  history.push({pathname: "/contents/daolSec/saNdid/loginNdid",
                  state: {token: param_token, identifier: param_identifier, ndid_phase: param_ndid_phase }})}
              >
                {t("btn_next")}
                <img src={iconNext} alt="icon-next" width="25" style={{border:"5px"}}/>
              </Button>
            </div>
            </>
          )}
        </div>
      </Row>
    </div>
    </>
  );
};

export default DaolSecNdidPage;
